import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native';

const kSize = 28;

export const BackButton = memo(
  ({
    style,
    size = kSize,
    color = '#fff',
    onPress,
  }: {
    onPress?: () => void;
    style?: StyleProp<ViewStyle>;
    color?: string;
    size?: number;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity onPress={onPress} style={[style]}>
        <Icon name="arrow-left-circle" size={rpx(size)} color={color} />
      </TouchableOpacity>
    );
  },
);
